import mapObject from 'underscore/modules/mapObject';
import { OPTIONAL_LANG } from 'tradera-apps/tradera/helpers/optional-lang';
import PAGE_TYPES from 'tradera-constants/page-types';

export const myTraderaUrls = {
    overview: '/my/overview',
    buyerOverview: '/my/overview-buyer',
    sellerOverview: '/my/overview-seller',
    accountOverview: '/my/overview-my-account',
    wishlist: '/my/wish-list',
    activeItems: '/my/active-items',
    itemsLost: '/my/items-lost',
    active: '/my/active',
    sold: '/my/sold',
    unsold: '/my/unsold',
    purchases: '/my/purchases',
    savedSearches: '/my/saved-searches',
    favouriteSellers: '/my/favourite-sellers',
    sellerList: '/my/seller-list',
    pickList: '/my/picklist',
    leaveFeedback: '/my/leave-feedback/:role',
    buyerFeedback: '/my/leave-feedback/buyer',
    sellerFeedback: '/my/leave-feedback/seller',
    myFeedback: '/my/feedback',
    invoices: '/my/Invoices',
    payments: '/my/Payments',
    payments2: '/my/Payments2',
    traderaPay: '/my/payments2/traderapay',
    payouts: '/my/payouts',
    messaging: '/messaging',
    selling: '/selling',
    settings: '/my/settings',
    settingsAccount: '/my/settings/account',
    settingsEmail: '/my/settings/email',
    settingsSelling: '/my/settings/selling',
    settingsNotifications: '/my/settings/notifications',
    settingsSecurity: '/my/settings/security',
    settingsPayouts: '/my/settings/payouts',
    buyShippingBags: '/tradera-shop/shipping-bags',
    payeeVerification: '/my/PayeeVerification',
    hyperwalletPayeeVerificationCompleted: '/my/PayeeVerificationCompleted',
    notFound: '/my/settings/*'
};

export const getMyTraderaUrls = toLocalizedUrl =>
    mapObject(myTraderaUrls, url => toLocalizedUrl(url));

export const myTraderaRouteUrls = mapObject(
    myTraderaUrls,
    url => `${OPTIONAL_LANG}${url}`
);

export const myTraderaRoutes = mapObject(
    {
        SellerListPage: {
            path: myTraderaRouteUrls.sellerList
        },
        PayeeVerificationPage: {
            path: myTraderaRouteUrls.payeeVerification
        },
        HyperwalletPayeeVerificationCompletedPage: {
            path: myTraderaRouteUrls.hyperwalletPayeeVerificationCompleted
        },
        TraderaPayPage: {
            path: myTraderaRouteUrls.traderaPay
        },
        BuyerActiveItemsPage: {
            path: myTraderaRouteUrls.activeItems
        },
        PurchasesPage: {
            path: myTraderaRouteUrls.purchases
        },
        ItemsLostPage: {
            path: myTraderaRouteUrls.itemsLost
        },
        ActivePage: {
            path: myTraderaRouteUrls.active
        },
        SoldPage: {
            path: myTraderaRouteUrls.sold
        },
        UnsoldPage: {
            path: myTraderaRouteUrls.unsold
        },
        PaymentsPage: {
            path: myTraderaRouteUrls.payments2
        },
        PayoutsPage: {
            path: myTraderaRouteUrls.payouts
        },
        SettingsPage: {
            path: myTraderaRouteUrls.settings,
            exact: true
        },
        SettingsAccountPage: {
            path: myTraderaRouteUrls.settingsAccount
        },
        SettingsEmailPage: {
            path: myTraderaRouteUrls.settingsEmail
        },
        SettingsNotificationsPage: {
            path: myTraderaRouteUrls.settingsNotifications
        },
        SettingsSellingPage: {
            path: myTraderaRouteUrls.settingsSelling
        },
        SettingsSecurityPage: {
            path: myTraderaRouteUrls.settingsSecurity
        },
        SettingsPayoutsPage: {
            path: myTraderaRouteUrls.settingsPayouts
        },
        LeaveFeedbackPage: {
            path: myTraderaRouteUrls.leaveFeedback
        },
        NotFoundPage: {
            path: myTraderaRouteUrls.notFound
        }
    },
    route => ({
        pageType: PAGE_TYPES.MY_TRADERA_PAGE,
        ...route
    })
);
